import React from "react";
import "../styles/CTAFinalContenidoAds.scss";

const CTAFinalContenidoAds = () => {
  return (
    <section className="ovit-ctaFinal">
      <div className="ovit-ctaFinal__bg" aria-hidden="true">
        <div className="ovit-ctaFinal__glow ovit-ctaFinal__glow--1" />
        <div className="ovit-ctaFinal__glow ovit-ctaFinal__glow--2" />
      </div>

      <div className="ovit-ctaFinal__container">
        <div className="ovit-ctaFinal__card">

          <div className="ovit-ctaFinal__badge">
            🚀 Es momento de activar tu negocio
          </div>

          <h2 className="ovit-ctaFinal__title">
            ¿Listo para generar <span>mensajes reales</span> esta semana?
          </h2>

          <p className="ovit-ctaFinal__desc">
            No necesitas más seguidores.  
            Necesitas estrategia, campañas bien estructuradas y contenido enfocado a conversión.
          </p>

          <div className="ovit-ctaFinal__actions">
            <a href="#planes" className="ovit-ctaFinal__btnPrimary">
              Ver planes
            </a>

            <a href="https://wa.me/525588093678?text=Hola,%20me%20interesa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios%20de%20marketing%20digital.%20Quiero%20hacer%20crecer%20mi%20negocio%20y%20generar%20m%C3%A1s%20clientes." target="_blank" rel="noopener noreferrer" className="ovit-ctaFinal__btnSecondary">
              Hablar por WhatsApp
            </a>
          </div>

          <div className="ovit-ctaFinal__note">
            *Te asesoramos según tu giro y tu presupuesto.
          </div>

        </div>
      </div>
    </section>
  );
};

export default CTAFinalContenidoAds;